import React from 'react'
const Icon = () => (
  <svg
    width="303"
    height="262"
    viewBox="0 0 303 262"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M104.229 42.4101C104.229 42.4101 144.038 72.5955 204.558 16.1544C258.305 -33.9695 302.191 45.1148 302.498 82.9869C302.896 132.046 248.75 171.301 275.027 203.524C301.304 235.746 222.917 288.957 180.67 242.907C128.116 185.622 113.879 232.166 83.9238 232.166C62.4246 232.166 18.2846 178.789 48.0918 139.078C73.1743 105.662 59.4948 94.5719 52.8703 82.9869C43.3143 66.2788 66.0079 20.9284 104.229 42.4101Z"
      fill="#F6F7F8"
    />
    <g opacity="0.25">
      <g opacity="0.41">
        <path
          d="M302.18 167.215C302.478 162.094 302.344 156.95 301.767 151.857C299.053 127.924 286.769 105.357 268.688 89.4337C262.238 83.7525 254.898 78.6637 250.7 71.1651C243.631 58.5366 244.166 44.0233 235.392 31.5549C226.608 19.0717 213.807 9.33686 199.371 4.33732C156.328 -10.5692 96.0663 13.7023 101.492 65.5349C101.511 65.7206 101.533 65.9912 101.556 66.3335C102.278 77.0999 93.8225 86.1524 83.0625 86.4075C43.3495 87.3491 9.1654 117.952 1.85077 156.716C-2.85363 181.646 4.84949 208.971 23.095 226.607C36.7148 239.771 54.9879 247.004 73.2709 251.973C109.928 261.938 148.503 264.026 186.3 260.216C221.68 256.65 259 246.484 281.881 219.278C294.087 204.764 301.08 186.153 302.18 167.215Z"
          fill="#B0BEC5"
        />
      </g>
    </g>
    <path
      d="M149.035 110.114H94.5088C92.3161 110.114 90.5332 108.33 90.5332 106.138V73.0585C90.5332 70.4178 92.6812 68.2698 95.322 68.2698H134.441C134.833 68.2698 135.15 68.5874 135.15 68.9787C135.15 69.37 134.833 69.6876 134.441 69.6876H95.3212C93.4625 69.6876 91.9504 71.1997 91.9504 73.0585V106.138C91.9504 107.548 93.0981 108.696 94.5081 108.696H149.035C150.445 108.696 151.592 107.548 151.592 106.138V73.9227C151.592 71.5875 149.692 69.6876 147.357 69.6876H139.8C139.408 69.6876 139.091 69.37 139.091 68.9787C139.091 68.5874 139.408 68.2698 139.8 68.2698H147.357C150.475 68.2698 153.01 70.8056 153.01 73.9227V106.138C153.01 108.331 151.227 110.114 149.035 110.114Z"
      fill="#263238"
    />
    <path
      d="M93.1219 109.144C92.9269 109.144 92.732 109.064 92.5923 108.906C92.3321 108.614 92.3584 108.166 92.6505 107.905L114.926 88.0883C115.218 87.8274 115.668 87.8544 115.927 88.1465C116.187 88.4392 116.161 88.8873 115.869 89.1475L93.5933 108.965C93.4579 109.085 93.2892 109.144 93.1219 109.144Z"
      fill="#263238"
    />
    <path
      d="M150.195 109.693C150.028 109.693 149.86 109.634 149.725 109.514L127.482 89.7968C127.189 89.5373 127.162 89.0893 127.421 88.7965C127.681 88.5016 128.129 88.4768 128.422 88.7362L150.665 108.454C150.958 108.714 150.985 109.162 150.726 109.454C150.586 109.612 150.391 109.693 150.195 109.693Z"
      fill="#263238"
    />
    <path
      d="M121.778 93.5534C121.041 93.5534 120.303 93.3223 119.675 92.8601L91.4709 72.1334C91.1555 71.9016 91.0874 71.4578 91.3192 71.1423C91.5511 70.8276 91.9949 70.7574 92.3103 70.9913L120.515 91.718C121.268 92.271 122.279 92.2724 123.034 91.723L150.637 71.5989C150.953 71.3685 151.397 71.4387 151.627 71.7541C151.858 72.0703 151.788 72.5141 151.472 72.7452L123.869 92.8693C123.243 93.3252 122.511 93.5534 121.778 93.5534Z"
      fill="#263238"
    />
    <path
      d="M149.517 63.8489C150.106 64.2807 150.897 64.2835 151.488 63.8525L174.947 46.7491C174.041 45.6297 172.657 44.913 171.105 44.913H129.032C127.734 44.913 126.58 45.5212 125.833 46.4655C125.86 46.4804 125.89 46.4846 125.915 46.5038L149.517 63.8489Z"
      fill="#546E7A"
    />
    <path
      d="M152.324 64.9981C151.78 65.3951 151.143 65.5928 150.506 65.5928C149.866 65.5928 149.225 65.3922 148.679 64.9903L145.097 62.358L126.998 78.4597C126.984 78.4718 126.967 78.476 126.953 78.4867C127.342 78.6504 127.77 78.7419 128.219 78.7419H172.783C173.036 78.7419 173.279 78.7071 173.516 78.6526L155.5 62.6827L152.324 64.9981Z"
      fill="#546E7A"
    />
    <path
      d="M143.928 61.4995L125.161 47.7089C125.027 48.1129 124.952 48.5433 124.952 48.9927V75.4758C124.952 76.3499 125.3 77.1397 125.86 77.726C125.896 77.6054 125.953 77.4906 126.054 77.4013L143.928 61.4995Z"
      fill="#546E7A"
    />
    <path
      d="M174.757 77.8593C174.798 77.8955 174.821 77.9416 174.851 77.9841C175.577 77.3851 176.049 76.4897 176.049 75.4759V49.8563C176.049 49.1892 175.915 48.554 175.675 47.9734L156.672 61.8285L174.757 77.8593Z"
      fill="#546E7A"
    />
    <g opacity="0.69">
      <path
        d="M176.127 144.527H139.119C136.927 144.527 135.145 142.743 135.145 140.551V119.071C135.145 116.43 137.293 114.282 139.933 114.282H174.45C177.566 114.282 180.103 116.817 180.103 119.934V140.551C180.102 142.744 178.318 144.527 176.127 144.527ZM139.933 115.7C138.074 115.7 136.562 117.212 136.562 119.071V140.551C136.562 141.961 137.709 143.109 139.119 143.109H176.126C177.537 143.109 178.684 141.961 178.684 140.551V119.934C178.684 117.6 176.784 115.7 174.448 115.7H139.933Z"
        fill="#90A4AE"
      />
      <path
        d="M152.595 128.468L136.716 142.604L137.659 143.663L153.538 129.527L152.595 128.468Z"
        fill="#90A4AE"
      />
      <path
        d="M162.484 128.925L161.544 129.985L177.405 144.045L178.345 142.984L162.484 128.925Z"
        fill="#90A4AE"
      />
      <path
        d="M157.628 132.718C157.061 132.718 156.493 132.54 156.009 132.185L135.896 117.404L136.735 116.262L156.848 131.042C157.312 131.383 157.937 131.384 158.404 131.045L179.241 115.854L180.076 116.999L159.238 132.19C158.758 132.542 158.193 132.718 157.628 132.718Z"
        fill="#90A4AE"
      />
    </g>
    <path
      d="M175.777 53.9658C180.695 53.9658 184.682 49.9787 184.682 45.0604C184.682 40.142 180.695 36.1549 175.777 36.1549C170.858 36.1549 166.871 40.142 166.871 45.0604C166.871 49.9787 170.858 53.9658 175.777 53.9658Z"
      fill="#43505C"
    />
    <path
      d="M173.805 48.5007H172.829V42.6075L171.839 43.215V42.2055L172.829 41.5455H173.805V48.5007Z"
      fill="white"
    />
    <path
      d="M175.889 48.0514C175.552 47.7033 175.384 47.2191 175.384 46.5974V43.4356C175.384 42.8103 175.553 42.3247 175.891 41.9788C176.229 41.6328 176.722 41.4598 177.369 41.4598C178.019 41.4598 178.513 41.6321 178.849 41.9766C179.185 42.3212 179.354 42.8075 179.354 43.4356V46.5974C179.354 47.2226 179.185 47.7083 178.847 48.0542C178.509 48.4002 178.016 48.5731 177.369 48.5731C176.718 48.5731 176.225 48.3995 175.889 48.0514ZM178.132 47.3744C178.296 47.1943 178.378 46.9348 178.378 46.5974V43.4356C178.378 43.0974 178.297 42.8387 178.134 42.6579C177.972 42.4778 177.716 42.3878 177.369 42.3878C177.021 42.3878 176.766 42.4778 176.603 42.6579C176.441 42.838 176.359 43.0974 176.359 43.4356V46.5974C176.359 46.9355 176.442 47.195 176.605 47.3744C176.77 47.5544 177.024 47.6445 177.369 47.6445C177.713 47.6445 177.968 47.5551 178.132 47.3744Z"
      fill="white"
    />
    <path
      d="M258.567 144.035C258.081 144.035 257.606 143.841 257.254 143.474L251.252 137.244C250.853 136.83 250.295 136.593 249.722 136.593L190.756 136.524C187.483 136.524 184.819 133.861 184.819 130.588V108.229C184.819 104.956 187.483 102.293 190.757 102.293H253.638C257.366 102.293 260.399 105.325 260.399 109.052V142.206C260.399 142.956 259.949 143.621 259.255 143.902C259.031 143.992 258.798 144.035 258.567 144.035ZM190.757 103.711C188.264 103.711 186.237 105.737 186.237 108.229V130.588C186.237 133.08 188.264 135.107 190.757 135.107L249.722 135.175C250.679 135.175 251.609 135.571 252.274 136.261L258.275 142.491C258.449 142.672 258.647 142.617 258.725 142.586C258.802 142.555 258.982 142.456 258.982 142.206V109.052C258.982 106.106 256.585 103.71 253.639 103.71H190.757V103.711Z"
      fill="#43505C"
    />
    <path
      d="M243.853 115.512H228.745C228.353 115.512 228.036 115.194 228.036 114.803C228.036 114.412 228.353 114.094 228.745 114.094H243.853C244.245 114.094 244.562 114.412 244.562 114.803C244.562 115.194 244.245 115.512 243.853 115.512Z"
      fill="#43505C"
    />
    <path
      d="M219.547 115.512H196.42C196.028 115.512 195.711 115.194 195.711 114.803C195.711 114.412 196.028 114.094 196.42 114.094H219.547C219.939 114.094 220.256 114.412 220.256 114.803C220.256 115.194 219.939 115.512 219.547 115.512Z"
      fill="#43505C"
    />
    <path
      d="M243.853 120.896H205.803C205.411 120.896 205.094 120.578 205.094 120.187C205.094 119.795 205.411 119.478 205.803 119.478H243.854C244.246 119.478 244.563 119.795 244.563 120.187C244.562 120.578 244.245 120.896 243.853 120.896Z"
      fill="#43505C"
    />
    <path
      d="M243.854 126.278H218.642C218.25 126.278 217.933 125.961 217.933 125.57C217.933 125.178 218.25 124.861 218.642 124.861H243.854C244.246 124.861 244.562 125.178 244.562 125.57C244.562 125.961 244.246 126.278 243.854 126.278Z"
      fill="#43505C"
    />
    <path
      d="M250.463 105.903H229.978C229.325 105.903 228.699 106.169 228.245 106.641L223.148 111.931C222.555 112.547 221.514 112.127 221.514 111.272V103.246V83.1195C221.514 80.2816 223.814 77.9812 226.652 77.9812H251.279C253.588 77.9812 255.46 79.8535 255.46 82.1624V100.907C255.459 103.667 253.222 105.903 250.463 105.903Z"
      fill="#263238"
    />
    <path
      d="M232.32 92.5623C232.32 93.5314 231.535 94.3162 230.566 94.3162C229.597 94.3162 228.812 93.5307 228.812 92.5623C228.812 91.594 229.598 90.8085 230.566 90.8085C231.535 90.8085 232.32 91.594 232.32 92.5623Z"
      fill="white"
    />
    <path
      d="M240.541 92.5623C240.541 93.5314 239.755 94.3162 238.787 94.3162C237.819 94.3162 237.033 93.5307 237.033 92.5623C237.033 91.594 237.819 90.8085 238.787 90.8085C239.756 90.8085 240.541 91.594 240.541 92.5623Z"
      fill="white"
    />
    <path
      d="M247.201 94.3162C248.17 94.3162 248.955 93.531 248.955 92.5623C248.955 91.5937 248.17 90.8085 247.201 90.8085C246.232 90.8085 245.447 91.5937 245.447 92.5623C245.447 93.531 246.232 94.3162 247.201 94.3162Z"
      fill="white"
    />
    <path
      d="M210.799 162.77H113.065C107.87 162.77 103.66 166.98 103.66 172.174V209.013V223.703C103.66 225.269 105.566 226.038 106.653 224.91L115.981 215.227C116.811 214.365 117.957 213.878 119.153 213.878L210.798 213.772C215.286 213.772 218.924 210.133 218.924 205.646V170.896C218.925 166.407 215.286 162.77 210.799 162.77Z"
      fill="#546E7A"
    />
    <path
      d="M151.754 182.044H128.273C127.758 182.044 127.342 181.626 127.342 181.112C127.342 180.598 127.758 180.18 128.273 180.18H151.754C152.269 180.18 152.686 180.598 152.686 181.112C152.686 181.626 152.269 182.044 151.754 182.044Z"
      fill="white"
    />
    <path
      d="M201.997 182.044H166.052C165.537 182.044 165.12 181.626 165.12 181.112C165.12 180.598 165.537 180.18 166.052 180.18H201.997C202.513 180.18 202.929 180.598 202.929 181.112C202.929 181.626 202.512 182.044 201.997 182.044Z"
      fill="white"
    />
    <path
      d="M187.414 190.411H128.273C127.757 190.411 127.341 189.994 127.341 189.479C127.341 188.965 127.757 188.548 128.273 188.548H187.414C187.929 188.548 188.345 188.965 188.345 189.479C188.345 189.994 187.929 190.411 187.414 190.411Z"
      fill="white"
    />
    <path
      d="M167.46 198.778H128.273C127.758 198.778 127.342 198.36 127.342 197.846C127.342 197.332 127.758 196.914 128.273 196.914H167.46C167.975 196.914 168.391 197.332 168.391 197.846C168.391 198.36 167.974 198.778 167.46 198.778Z"
      fill="white"
    />
    <path
      d="M86.5396 164.721H113.769C114.639 164.721 115.471 165.075 116.073 165.7L122.848 172.732C123.637 173.551 125.021 172.993 125.021 171.855V161.188V134.435C125.021 130.662 121.964 127.606 118.192 127.606H85.457C82.387 127.606 79.8994 130.094 79.8994 133.163V158.079C79.8985 161.748 82.8724 164.721 86.5396 164.721Z"
      fill="#263238"
    />
    <path
      d="M110.655 146.988C110.655 148.275 111.699 149.319 112.986 149.319C114.274 149.319 115.317 148.275 115.317 146.988C115.317 145.7 114.274 144.657 112.986 144.657C111.7 144.656 110.655 145.7 110.655 146.988Z"
      fill="white"
    />
    <path
      d="M99.7285 146.988C99.7285 148.275 100.772 149.319 102.06 149.319C103.347 149.319 104.391 148.275 104.391 146.988C104.391 145.7 103.347 144.657 102.06 144.657C100.772 144.656 99.7285 145.7 99.7285 146.988Z"
      fill="white"
    />
    <path
      d="M88.5449 146.988C88.5449 148.275 89.5884 149.319 90.876 149.319C92.1636 149.319 93.2071 148.275 93.2071 146.988C93.2071 145.7 92.1636 144.657 90.876 144.657C89.5884 144.656 88.5449 145.7 88.5449 146.988Z"
      fill="white"
    />
    <path
      d="M225.199 179.669C230.85 174.017 230.85 164.853 225.199 159.201C219.547 153.549 210.383 153.549 204.731 159.201C199.079 164.853 199.079 174.017 204.731 179.669C210.383 185.321 219.547 185.321 225.199 179.669Z"
      fill="#B0BEC5"
    />
    <path
      d="M216.625 176.194H214.634V164.168L212.614 165.408V163.348L214.634 162.001H216.625V176.194Z"
      fill="white"
    />
  </svg>
)
export default Icon
